<script setup lang="ts">
import {computed} from 'vue'

const props = withDefaults(
  defineProps<{
    percent: number
    size?: number
    strokeWidth?: number
  }>(),
  {size: 16, strokeWidth: 2.5}
)

const radius = computed(() => (props.size - props.strokeWidth) / 2)
const circumference = computed(() => 2 * Math.PI * radius.value)
const clamped = computed(() => Math.min(100, Math.max(0, props.percent)))
const dashOffset = computed(() => circumference.value * (1 - clamped.value / 100))
</script>

<template>
  <svg :width="size" :height="size" :viewBox="`0 0 ${size} ${size}`" class="-rotate-90" aria-hidden="true">
    <circle
      cx="50%"
      cy="50%"
      :r="radius"
      fill="none"
      stroke="currentColor"
      class="text-muted-foreground/30"
      :stroke-width="strokeWidth" />
    <circle
      cx="50%"
      cy="50%"
      :r="radius"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      :stroke-width="strokeWidth"
      :stroke-dasharray="circumference"
      :stroke-dashoffset="dashOffset" />
  </svg>
</template>
